module.exports = __webpack_public_path__ + "img/me.cf234164.png";